import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import RankedQueryCard from "../../charts/RankedQueryCard";
import { offerUnsubscriptionsQuery } from "../offerAnalytics.queries";
import {
  buildUnsubscriptionsByOffer,
  filterByOffer,
} from "../offerAnalytics.utils";
import useMissingOfferLabel from "../useMissingOfferLabel";

import type { JSX } from "react";

import type { GetOfferUnsubscriptionsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries } from "../../charts/charts.types";
import type {
  CountSeriesKey,
  OfferAnalyticsFilterProps,
} from "../offerAnalytics.types";

function UnsubscriptionsByOfferCard({
  filters,
}: OfferAnalyticsFilterProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");
  const { offerUuid } = filters;
  const getMissingOfferLabel = useMissingOfferLabel();

  const seriesList = useMemo(
    (): ChartSeries<CountSeriesKey>[] => [
      {
        key: "count",
        label: t("offerAnalytics.series.unsubscriptions"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetOfferUnsubscriptionsResponse | undefined) =>
      buildUnsubscriptionsByOffer(
        filterByOffer(
          response?.data ?? [],
          offerUuid,
          (unsubscription) => unsubscription.offer_uuid,
        ),
        getMissingOfferLabel,
      ),
    [offerUuid, getMissingOfferLabel],
  );

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      query={offerUnsubscriptionsQuery(projectSlug, filters)}
      seriesList={seriesList}
      title={t("offerAnalytics.charts.unsubscriptionsByOffer")}
    />
  );
}

export default UnsubscriptionsByOfferCard;
